module.exports = __webpack_public_path__ + "img/crystal-2.822c4c7c.png";